/**
 * Local UI templates for composed screens (bank subset).
 * Live next_question from API overrides text/options when present.
 */
import catalog from './screeningBankUi.json'

export function catalogQuestion(questionId) {
  const raw = catalog[questionId]
  if (!raw) {
    return null
  }
  return {
    question_id: raw.id || questionId,
    phase: 'PRE_MATCH',
    type: raw.type,
    required: raw.required !== false,
    text: raw.text || null,
    labels: raw.labels || [],
    options: raw.options || null,
    options_source: raw.options_source || null,
    presentation_by_intent: raw.presentation_by_intent || null,
    validation: raw.validation || null,
  }
}

/**
 * Merge API lead question onto catalog entry (API wins for options/text).
 */
export function resolveQuestion(questionId, liveQuestion) {
  const base = catalogQuestion(questionId) || {
    question_id: questionId,
    type: 'SINGLE_SELECT',
    required: true,
    text: questionId,
    options: [],
  }
  let merged
  if (!liveQuestion || liveQuestion.question_id !== questionId) {
    merged = Object.assign({}, base)
  } else {
    merged = Object.assign({}, base, {
      text: liveQuestion.text != null ? liveQuestion.text : base.text,
      type: liveQuestion.type || base.type,
      required: liveQuestion.required != null ? liveQuestion.required : base.required,
      options: liveQuestion.options != null ? liveQuestion.options : base.options,
      presentation_by_intent: liveQuestion.presentation_by_intent || base.presentation_by_intent,
      validation: liveQuestion.validation || base.validation,
      labels: liveQuestion.labels || base.labels,
      s1_intent: liveQuestion.s1_intent || null,
      participant_ref: liveQuestion.participant_ref || null,
    })
  }
  // YES_NO with empty options (common in Assets bank) → default بله/خیر
  if (merged.type === 'YES_NO' && (!Array.isArray(merged.options) || !merged.options.length)) {
    merged.options = [
      {id: 'YES', label: 'بله'},
      {id: 'NO', label: 'خیر'},
    ]
  }
  return merged
}

export function resolveQuestionList(ids, liveLead, context) {
  const needLabel = (context && context.needLabel)
    || extractNeedLabel(liveLead && liveLead.text)
  return ids.map((id, index) => {
    const live = index === 0 ? liveLead : null
    return applyNeedLabel(resolveQuestion(id, live), needLabel)
  })
}

/** Pull Persian need label from API-substituted «…» in severity prompts. */
export function extractNeedLabel(text) {
  const m = String(text || '').match(/«([^»]+)»/)
  return m ? m[1] : null
}

export function applyNeedLabel(question, needLabel) {
  if (!question || !needLabel || !question.text) {
    return question
  }
  if (String(question.text).indexOf('{need_label}') === -1) {
    return question
  }
  return Object.assign({}, question, {
    text: String(question.text).split('{need_label}').join(needLabel),
  })
}
